import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
// Chakra imports
import {
  Image,
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
// Custom components
import { HSeparator } from 'components/separator/Separator';
import DefaultAuth from 'layouts/auth/Default';
// Assets
import illustration from 'assets/img/tablet-login-concept-illustration_114360-7963.avif';
import { FcGoogle } from 'react-icons/fc';
import { MdOutlineRemoveRedEye } from 'react-icons/md';
import { RiEyeCloseLine } from 'react-icons/ri';
import { useToast } from '@chakra-ui/react';
import axiosInstance from '../../../axiosInstance';
import baseUrl from 'Base_Url/baseUrl';
import MainImage from '../../../assets/img/Dashboard_screenshot.svg';
import { notifyApiError } from 'utils/apiFeedback';

const companyLogo = '/gujcomasol-logo-separate.png';

function SignIn() {
  // Chakra color mode
  const textColor = useColorModeValue('navy.700', 'white');
  const textColorSecondary = 'gray.400';
  const textColorDetails = useColorModeValue('navy.700', 'secondaryGray.600');
  const textColorBrand = useColorModeValue('brand.500', 'white');
  const brandStars = useColorModeValue('brand.500', 'brand.400');
  const googleBg = useColorModeValue('secondaryGray.300', 'whiteAlpha.200');
  const googleText = useColorModeValue('navy.700', 'white');
  const primaryColor = 'rgba(16, 114, 187, 1)';
  const googleHover = useColorModeValue(
    { bg: 'gray.200' },
    { bg: 'whiteAlpha.300' },
  );
  const googleActive = useColorModeValue(
    { bg: 'secondaryGray.300' },
    { bg: 'whiteAlpha.200' },
  );
  const [show, setShow] = React.useState(false);
  const handleClick = () => setShow(!show);

  const [formData, setFormData] = useState({
    emailOrUsername: '',
    password: '',
  });

  const [loading, setLoading] = useState(false);

  const linkStyle = {
    textDecoration: 'underline',
    color: '#007bff',
    display: 'block',
    marginTop: '1rem',
    cursor: 'pointer',
  };

  const hoverStyle = {
    color: '#0056b3',
  };

  const navigate = useNavigate();
  const toast = useToast();

  const login = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `${baseUrl}/auth/login`,
        formData,
      );
      // return;
      if (response && response?.data && response?.data?.data) {
        setLoading(false);
        localStorage.setItem('role', response?.data?.data?.userObj?.role);
        localStorage.setItem(
          'token',
          response?.data?.data?.tokens?.access?.token,
        );
        localStorage.setItem('name', response?.data?.data?.userObj?.name);
        localStorage.setItem(
          'companyId',
          response?.data?.data?.userObj?.companyId,
        );
        localStorage.setItem(
          'username',
          response?.data?.data?.userObj?.username,
        );
        localStorage.setItem(
          'nocNumber',
          response?.data?.data?.userObj?.nocNumber,
        );
        localStorage.setItem(
          'nocStartDate',
          response?.data?.data?.userObj?.nocStartDate,
        );
        localStorage.setItem(
          'nocEndDate',
          response?.data?.data?.userObj?.nocEndDate,
        );
        localStorage.setItem(
          'limitPerDay',
          response?.data?.data?.userObj?.limitPerDay,
        );
        localStorage.setItem(
          'limitPerYear',
          response?.data?.data?.userObj?.limitPerYear,
        );
        localStorage.setItem(
          'nocPdfFileName',
          response?.data?.data?.userObj?.nocPdfFileName,
        );
        localStorage.setItem(
          'companyLogoUrl',
          response?.data?.data?.userObj?.companyLogoUrl || '',
        );
        if (response?.data?.data?.userObj?.email !== undefined) {
          localStorage.setItem('email', response?.data?.data?.userObj?.email);
        }
        if (response?.data?.data?.userObj?.district !== undefined) {
          localStorage.setItem(
            'district',
            response?.data?.data?.userObj?.district,
          );
        }
        if (response?.data?.data?.userObj?.companyName !== undefined) {
          localStorage.setItem(
            'companyName',
            response?.data?.data?.userObj?.companyName,
          );
        }
        const userRole = response.data.data.userObj.role;
        toast({
          title: 'Login Successful',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
        setTimeout(() => {
          if (userRole === 'baseuser') {
            navigate('/admin/analytics');
          } else {
            navigate('/admin/dashboard');
          }
          window.location.reload();
        }, 500);
      }
    } catch (error) {
      setLoading(false);
      notifyApiError(error, toast, 'Invalid username or password');
    }
  };

  const handleSignup = () => {
    navigate('/create-company');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // return (
  //   <DefaultAuth illustrationBackground={illustration} image={illustration}>
  //     <Flex
  //       maxW={{ base: '100%', md: 'max-content' }}
  //       w="100%"
  //       mx={{ base: 'auto', lg: '0px' }}
  //       me="auto"
  //       h="100%"
  //       alignItems="center" // Center content horizontally
  //       justifyContent="center"
  //       mb={{ base: '30px', md: '60px' }}
  //       px={{ base: '25px', md: '0px' }}
  //       mt={{ base: '20px', md: '7vh' }}
  //       flexDirection="column"
  //       style={{
  //         border: '0.1px solid gray',
  //         padding: '10px',
  //         boxShadow: '10px 10px 5px grey',
  //         borderRadius: '10px',
  //       }}
  //     >
  //       <Box me="auto">
  //         <Image
  //           src={companyLogo}
  //           alt="Company Logo"
  //           mb="20px"
  //           boxSize="100px"
  //           objectFit="contain"
  //           style={{
  //             width: '70%',
  //             margin: '0 auto',
  //           }}
  //         />
  //         <Heading color={textColor} fontSize="36px" mb="10px">
  //           Sign In
  //         </Heading>
  //         <Text
  //           mb="36px"
  //           ms="4px"
  //           color={textColorSecondary}
  //           fontWeight="400"
  //           fontSize="md"
  //         >
  //           Enter your email or username and password to sign in!
  //         </Text>
  //       </Box>
  //       <Flex
  //         zIndex="2"
  //         direction="column"
  //         w={{ base: '100%', md: '420px' }}
  //         maxW="100%"
  //         background="transparent"
  //         borderRadius="15px"
  //         mx={{ base: 'auto', lg: 'unset' }}
  //         me="auto"
  //         mb={{ base: '20px', md: 'auto' }}
  //       >
  //         {/* <Button
  //           fontSize="sm"
  //           me="0px"
  //           mb="26px"
  //           py="15px"
  //           h="50px"
  //           borderRadius="16px"
  //           bg={googleBg}
  //           color={googleText}
  //           fontWeight="500"
  //           _hover={googleHover}
  //           _active={googleActive}
  //           _focus={googleActive}
  //         >
  //           <Icon as={FcGoogle} w="20px" h="20px" me="10px" />
  //           Sign in with Google
  //         </Button>
  //         <Flex align="center" mb="25px">
  //           <HSeparator />
  //           <Text color="gray.400" mx="14px">
  //             or
  //           </Text>
  //           <HSeparator />
  //         </Flex> */}
  //         <FormControl as="form" onSubmit={login}>
  //           <FormLabel
  //             display="flex"
  //             ms="4px"
  //             fontSize="sm"
  //             fontWeight="500"
  //             color={textColor}
  //             mb="8px"
  //           >
  //             Email or Username<Text color={brandStars}>*</Text>
  //           </FormLabel>
  //           <Input
  //             name="emailOrUsername"
  //             isRequired={true}
  //             variant="auth"
  //             fontSize="sm"
  //             ms={{ base: '0px', md: '0px' }}
  //             type="text"
  //             value={formData.emailOrUsername}
  //             placeholder="Email or Username"
  //             mb="24px"
  //             fontWeight="500"
  //             size="lg"
  //             onChange={handleInputChange}
  //           />
  //           <FormLabel
  //             ms="4px"
  //             fontSize="sm"
  //             fontWeight="500"
  //             color={textColor}
  //             display="flex"
  //           >
  //             Password<Text color={brandStars}>*</Text>
  //           </FormLabel>
  //           <InputGroup size="md">
  //             <Input
  //               name="password"
  //               isRequired={true}
  //               fontSize="sm"
  //               placeholder="Min. 8 characters"
  //               mb="24px"
  //               size="lg"
  //               type={show ? 'text' : 'password'}
  //               variant="auth"
  //               value={formData.password}
  //               onChange={handleInputChange}
  //             />
  //             <InputRightElement display="flex" alignItems="center" mt="4px">
  //               <Icon
  //                 color={textColorSecondary}
  //                 _hover={{ cursor: 'pointer' }}
  //                 as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
  //                 onClick={handleClick}
  //               />
  //             </InputRightElement>
  //           </InputGroup>
  //           <Flex justifyContent="space-between" align="center" mb="24px">
  //             {/* <FormControl display="flex" alignItems="center">
  //               <Checkbox
  //                 id="remember-login"
  //                 colorScheme="brandScheme"
  //                 me="10px"
  //               />
  //               <FormLabel
  //                 htmlFor="remember-login"
  //                 mb="0"
  //                 fontWeight="normal"
  //                 color={textColor}
  //                 fontSize="sm"
  //               >
  //                 Keep me logged in
  //               </FormLabel>
  //             </FormControl> */}
  //             {/* <NavLink to="/auth/forgot-password">
  //               <Text
  //                 color={textColorBrand}
  //                 fontSize="sm"
  //                 w="124px"
  //                 fontWeight="500"
  //               >
  //                 Forgot password?
  //               </Text>
  //             </NavLink> */}
  //           </Flex>
  //           <Button
  //             fontSize="sm"
  //             variant="brand"
  //             fontWeight="500"
  //             w="100%"
  //             h="50"
  //             mb="24px"
  //             type="submit"
  //             isLoading={loading}
  //           >
  //             Sign In
  //           </Button>
  //         </FormControl>
  //         {/* <Flex
  //           flexDirection="column"
  //           justifyContent="center"
  //           alignItems="start"
  //           maxW="100%"
  //           mt="0px"
  //         >
  //           <Text color={textColorDetails} fontWeight="400" fontSize="14px">
  //             Not registered yet?
  //             <NavLink to="/auth/sign-up">
  //               <Text
  //                 color={textColorBrand}
  //                 as="span"
  //                 ms="5px"
  //                 fontWeight="500"
  //               >
  //                 Create an Account
  //               </Text>
  //             </NavLink>
  //           </Text>
  //         </Flex> */}
  //       </Flex>
  //     </Flex>
  //   </DefaultAuth>
  // );

  // Assuming you have imported necessary components from Chakra UI,
  // and the icons (MdOutlineRemoveRedEye, RiEyeCloseLine, etc.)

  return (
    <DefaultAuth>
      {/* Main Container for the two-column layout: Sign-in Form (Left) and Image (Right) */}
      <Flex h="100vh" w="100%" align="center" justify="center">
        {/* ================================================================================
        Left Column: Sign-in Form (White Card) 
        ================================================================================
      */}
        <Flex
          maxW={{ base: '80%', sm: '450px' }} // Adjusted max-width to make the card slightly smaller
          w="100%"
          mx={{ base: 'auto', lg: '0px' }} // Centered horizontally within its space on larger screens
          me="auto" // This pushes it to the left, but we need it centered relative to the whole page, so adjust the parent Flex
          h="75%"
          alignItems="center"
          justifyContent="center"
          px={{ base: '25px', md: '0px' }}
          py={{ base: '25px', md: '0px' }}
          flexDirection="column"
          bg="white" // White background for the card
          borderRadius="20px" // Rounded corners as per image
          boxShadow="xl" // Subtle shadow
          position="relative" // Important for absolute positioning of the logo
          style={{
            background: 'linear-gradient(180deg, #1072BB -258.18%, #FFF 29.5%)',
            border: '1px solid rgba(16,114,187,0.26)', // Added a very light border to define the edge
            boxShadow: '0 24px 26px 0 rgba(0, 89, 155, 0.10)',
          }}
          mr={{ lg: '100px' }} // Added margin-right for separation from the right panel
        >

          {/* Company Logo - Positioned at the top of the sign-in form */}
            <Flex justify="center" mb="20px">
              <Image
                src={companyLogo}
                alt="Company Logo"
                // mt="-50px"
                // pb="20px"
                h="70px"
                w="auto"
                objectFit="contain"
              />
            </Flex>
          <Box w="85%" maxW="375px" pt="10px">
              
            {/* Sign In Heading and Subtext */}
            <Heading
              color={textColor}
              fontSize="32px"
              mb="10px"
              fontWeight="700"
              textAlign="center"
            >
              Sign in
            </Heading>
            <Text
              mb="24px"
              color={textColorSecondary}
              fontWeight="500"
              fontSize="md"
              textAlign="center"
            >
              Enter your email or username and password to sign in!
            </Text>
            <Flex
              zIndex="2"
              direction="column"
              w="100%"
              maxW="100%"
              background="transparent"
            >
              <FormControl as="form" onSubmit={login}>
                {/* Email Input Field */}
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="6px"
                >
                  Email
                </FormLabel>
                <Input
                  name="emailOrUsername"
                  isRequired={true}
                  variant="outline"
                  fontSize="sm"
                  type="text"
                  value={formData.emailOrUsername}
                  placeholder="Enter your email"
                  mb="18px"
                  fontWeight="500"
                  h="44px"
                  onChange={handleInputChange}
                  borderRadius="8px"
                  // Subtle gradient effect for inputs (can be achieved with a lighter shadow or specific border)
                  // Using boxShadow for a subtle lift, simulating a slight gradient
                  boxShadow="rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
                  _focus={{
                    boxShadow:
                      'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
                  }}
                />

                {/* Password Input Field */}
                <FormLabel
                  ms="4px"
                  fontSize="sm"
                  fontWeight="500"
                  color={textColor}
                  mb="8px"
                >
                  Password
                </FormLabel>
                <InputGroup size="md">
                  <Input
                    name="password"
                    isRequired={true}
                    fontSize="sm"
                    placeholder="Enter your password"
                    mb="12px"
                    h="44px"
                    type={show ? 'text' : 'password'}
                    variant="outline"
                    value={formData.password}
                    onChange={handleInputChange}
                    borderRadius="8px"
                    // Subtle gradient effect for inputs
                    boxShadow="rgba(0, 0, 0, 0.05) 0px 1px 2px 0px"
                    _focus={{
                      boxShadow:
                        'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
                    }}
                  />
                  {/* Eye Icon for Password Visibility */}
                  <InputRightElement
                    display="flex"
                    alignItems="center"
                    h="100%"
                  >
                    <Icon
                      color={textColorSecondary}
                      _hover={{ cursor: 'pointer' }}
                      as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
                      onClick={handleClick}
                    />
                  </InputRightElement>
                </InputGroup>

                {/* Remember Me Checkbox and Forgot Password Link */}
                <Flex
                  justifyContent="space-between"
                  align="center"
                  mt="15px"
                  mb="40px"
                >
                  <FormControl display="flex" alignItems="center" w="auto">
                    <Checkbox
                      id="remember-login"
                      _checked={{
                        // 1. Set the background color for the box when checked
                        'span:first-of-type': {
                          bg: 'rgba(0, 106, 184, 1)',
                          borderColor: { primaryColor }, // Ensure border matches background
                          color: 'white', // Ensure the checkmark icon is white
                        },
                      }}
                      me="10px"
                      defaultChecked
                    />
                    <FormLabel
                      htmlFor="remember-login"
                      mb="0"
                      fontWeight="normal"
                      color={textColor}
                      fontSize="sm"
                    >
                      Remember me
                    </FormLabel>
                  </FormControl>

                  <NavLink to="/auth/forgot-password">
                    <Text
                      color={primaryColor}
                      fontSize="sm"
                      fontWeight="500"
                      _hover={{ textDecoration: 'underline' }}
                    >
                      Forgot Password?
                    </Text>
                  </NavLink>
                </Flex>

                {/* Sign In Button */}
                <Button
                  color="white"
                  fontSize="md"
                  variant="solid"
                  fontWeight="500"
                  w="100%"
                  h="48px"
                  mb="30px"
                  type="submit"
                  isLoading={loading}
                  backgroundColor={primaryColor}
                  borderRadius="8px"
                  // Subtle gradient for button (can be a slight shadow or linear gradient)
                  // For a Chakra button, a subtle box-shadow combined with a stronger hover might simulate gradient.
                  boxShadow="lg" // Larger shadow for the button to give it more lift
                  _hover={{ boxShadow: 'xl' }} // Even more lift on hover
                >
                  Sign in
                </Button>
              </FormControl>

              {/* "Don't have an account?" link */}
              <Flex
                flexDirection="row"
                justifyContent="center"
                alignItems="center"
              >
                <Text color={textColorSecondary} fontWeight="400" fontSize="sm">
                  Don't have an account?
                  <NavLink to="/auth/create-company">
                    <Text
                      // onClick={handleSignup()}
                      color={primaryColor}
                      as="span"
                      ms="5px"
                      fontWeight="500"
                      _hover={{ textDecoration: 'underline' }}
                    >
                      Register Now
                    </Text>
                  </NavLink>
                </Text>
              </Flex>
            </Flex>
          </Box>
        </Flex>

        {/* ================================================================================
        Right Column: Promotional Image (Blue Background)
        ================================================================================
      */}
        <Flex
          display={{ base: 'none', lg: 'flex' }}
          w="100%"
          h="90vh"
          bg="blue.600"
          align="center"
          justify="center"
          position="relative"
          p="20px"
          flexDirection="column"
          borderRadius="2xl"
        >
          <Box
            textAlign="center"
            color="white"
            maxW="450px"
            zIndex="3"
            mt="15px"
          >
            <Heading fontSize="4xl" mb="8px" fontWeight="700">
              Welcome Back!
              <br />
              Please sign in to your Aquakrishi account
            </Heading>
            <Text fontSize="md" fontWeight="800" mb="10px">
              Powered by Aquasense.
            </Text>
            <Text fontSize="md" fontWeight="400">
              Digital Irrigation Intelligence for Water-Secure and Farmer-Centric Agriculture
            </Text>
          </Box>

          {/* Dummy image representation */}
          <Box
            mt="10px"
            p="20px"
            // bg="rgba(255, 255, 255, 0.1)"
            borderRadius="15px"
            w="100%"
            maxW="600px"
            h="400px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            zIndex="3"
          >
            {/* Replace this with your actual Dashboard screenshot image */}
            {/* <Text color="whiteAlpha.700" fontSize="xl" fontWeight="600">
              [DASHBOARD PREVIEW IMAGE HERE]
            </Text> */}
            <Image
              src={MainImage} // You need to have the actual Aquasense logo imported here
              alt="Aquasense Logo"
              // h="100px" // Slightly smaller height for the logo
              w="100%"
              objectFit="contain"
            />
          </Box>

          {/* Simple white dots for a visual element at the bottom */}
          <Flex position="absolute" bottom="20px" zIndex="3">
            <Box
              w="8px"
              h="8px"
              bg="white"
              borderRadius="full"
              mx="4px"
              opacity="0.5"
            />
            <Box w="8px" h="8px" bg="white" borderRadius="full" mx="4px" />
            <Box
              w="8px"
              h="8px"
              bg="white"
              borderRadius="full"
              mx="4px"
              opacity="0.5"
            />
          </Flex>
        </Flex>
      </Flex>
    </DefaultAuth>
  );
}

export default SignIn;
